import {loggedInUserState} from "atoms/loggedInUserState";
import {useRecoilValue} from "recoil";

const RoleBasedRender = ({roles, children}) => {
  const loggedInUser = useRecoilValue(loggedInUserState);
  console.log("loggedInUser", loggedInUser?.role);
  if (roles && roles.includes(loggedInUser?.role)) {
    return children;
  }
  return null;
};

export default RoleBasedRender;
